<script>
  /**
   * Firebase 初期化コンポーネント
   */
  import { FirebaseApp } from '../../modules/sveltefire'

  import firebase from 'firebase/app'
  import 'firebase/firestore'
  export let db

  const firebaseConfig = {
    apiKey: 'AIzaSyDZ8Q0SNnXIo4s6FhiBzXUk6Jf4xH9dt9A',
    authDomain: 'fukudakg.firebaseapp.com',
    databaseURL: 'https://fukudakg.firebaseio.com',
    projectId: 'fukudakg',
    storageBucket: 'fukudakg.appspot.com',
    messagingSenderId: '792270911560',
    appId: '1:792270911560:web:12f7d59c2dd4e1ac6fc07d',
    measurementId: 'G-6EYY09Q2YG',
  }

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
    // オフライン モードの有効化
    //  https://cloud.google.com/firestore/docs/manage-data/enable-offline?hl=ja#web-version-8
    //  https://firebase.google.com/docs/reference/js/v8/firebase.firestore.PersistenceSettings
    firebase.firestore().enablePersistence({ synchronizeTabs: true })
  }

  db = firebase.firestore()
</script>

<FirebaseApp {firebase}>
  <slot />
</FirebaseApp>
